if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /**
         * Form edit toggle
         * Toggle edit mode on form elements
         * Expects buttons with classnames: 'change', 'confirm' & 'cancel' within container
         */
        ZZ.FormeditToggle = function(container) {
            var base = this;

            base.container = container;

            base.edit = base.container.find(".change");
            base.confirm = base.container.find(".confirm");
            base.cancel = base.container.find(".cancel");

            base.submitHandler = new ZZ.SubmitHandler(
                base.container,
                base.confirm
            );
            base.messageHandler = new ZZ.MessageHandler(base.container);

            base.config = $.extend(
                {},
                base._defaultConfig,
                base.container.data()
            );

            // variable used to backup current state in case of cancelation of edit-modus
            base.backup = {};

            base.checkForEmptyInformation();
            base.assignListeners();
        };

        ZZ.FormeditToggle.prototype = {
            _defaultConfig: {
                editmodusClassname: "edit-modus",
                errorText:
                    "Er is een fout opgetreden tijdens het opslaan. Probeert u het later nog eens."
            },

            assignListeners: function() {
                var base = this;

                base.edit.on("click", function(e) {
                    e.preventDefault();
                    base.container.addClass(base.config.editmodusClassname);
                    var firstInput = base.container
                        .find("input, textarea, select")
                        .first();
                    if (!firstInput.hasClass("placeholder-active")) {
                        firstInput.focus();
                    }
                    // store current data in backup
                    base.backup = base.container.find(">ol").clone(true, true);
                });

                base.cancel.on("click", function(e) {
                    e.preventDefault();
                    base.container.removeClass(base.config.editmodusClassname);
                    // revert to backup
                    base.container.find(">ol").replaceWith(base.backup);
                });

                base.container.find(".btn.add").on("click", function() {
                    base.backup = base.container.find(">ol").clone(true, true);
                });

                base.submitHandler.onBeforeSubmit = function() {
                    base.messageHandler.hideMessage();
                };

                base.submitHandler.handleSubmitResponse = function(data) {
                    if (
                        data.validation.toUpperCase() !== "OK" &&
                        typeof data.fields !== "undefined"
                    ) {
                        base.handleValidationErrors(data.fields);
                    } else {
                        base.container.removeClass(
                            base.config.editmodusClassname
                        );
                        base.updateFields(data);
                    }
                    if (typeof data.message !== "undefined") {
                        base.messageHandler.showMessage(data.message);
                    }
                };

                base.submitHandler.handleError = function() {
                    base.container.removeClass(base.config.editmodusClassname);
                    base.messageHandler.showMessage(base.config.errorText);
                };
            },

            handleValidationErrors: function(validationArray) {
                var validationObject = new ZZ.FormValidation();
                validationObject.validateMultipleFields(validationArray);
            },

            updateFields: function(data) {
                var base = this,
                    formRows = base.container.find(".form-row"),
                    formRowsLength = formRows.length,
                    curRow,
                    curInfoContainer,
                    curInputs,
                    i;

                for (i = 0; i < formRowsLength; i++) {
                    curRow = $(formRows[i]);
                    curInputs = curRow.find(".information-edit :input");
                    if (curInputs.length === 0) {
                        curInputs = curRow.find(".information.add :input");
                    }
                    if (curInputs.length > 0) {
                        curInfoContainer = curRow.find(".information");
                        var html = base.getValue(curInputs);
                        if (data[curInputs.attr("name")] !== undefined) {
                            html = data[curInputs.attr("name")];
                        }
                        curInfoContainer.html(html);
                    }
                }
                base.checkForEmptyInformation();
            },

            getValue: function(inputs) {
                var result = "",
                    type = inputs.attr("type");
                // address
                if (
                    inputs.attr("data-lookup-id") &&
                    inputs.attr("data-lookup-id") === "postalcode"
                ) {
                    result = $(inputs[0])
                        .parents(".information-edit, .information.add")
                        .find("[data-lookup-id=result]")
                        .html();
                }
                // checkboxes and radiobuttons
                else if (type === "checkbox" || type === "radio") {
                    var checked = inputs.filter(":checked");
                    checked.each(function() {
                        result += result.length > 0 ? ", " : "";
                        result += $(this).val();
                    });
                }
                // selectbox
                else if (inputs[0].tagName.toLocaleUpperCase() === "SELECT") {
                    result = inputs.find(":selected").text();
                }
                // password
                else if (type === "password") {
                    result = "********";
                }
                // default
                else {
                    result = inputs.val();
                }
                return "<span>" + result + "</span>";
            },

            // hide empty information containers when not in edit modus
            checkForEmptyInformation: function() {
                var base = this;
                if (base.container.hasClass(base.config.editmodusClassname)) {
                    return;
                }
                var infoContainer = base.container.find(".information");
                var curInfo;
                infoContainer.each(function(index, infoContainer) {
                    curInfo = $(infoContainer);
                    if ($.trim(curInfo.text()) === "") {
                        curInfo.parent().addClass("empty");
                    } else {
                        curInfo.parent().removeClass("empty");
                    }
                });
            }
        };

        /**
         * Toggle edit form
         * Toggle form open/close to edit input data (replaces previously used Form Edit functionality)
         * Expects buttons with classnames: 'change', 'confirm' & 'cancel' within container
         */
        ZZ.ToggleEditForm = function(container) {
            var base = this;

            base.container = container;

            base.edit = base.container.find(".change");
            base.confirm = base.container.find(".confirm");
            base.cancel = base.container.find(".cancel");

            base.form = base.container.find(".edit-form");

            base.submitHandler = new ZZ.SubmitHandler(
                base.container,
                base.confirm
            );
            base.messageHandler = new ZZ.MessageHandler(base.container);

            base.config = $.extend(
                {},
                base._defaultConfig,
                base.container.data()
            );

            base.assignListeners();
        };

        ZZ.ToggleEditForm.prototype = {
            _defaultConfig: {
                editmodusClassname: "edit-modus",
                errorText:
                    "Er is een fout opgetreden tijdens het opslaan. Probeert u het later nog eens."
            },

            assignListeners: function() {
                var base = this;

                base.edit.on("click", function(e) {
                    e.preventDefault();

                    base.container.addClass(base.config.editmodusClassname);
                    base.form.slideDown(200);

                    var firstInput = base.container
                        .find("input, textarea, select")
                        .first();
                    if (!firstInput.hasClass("placeholder-active")) {
                        firstInput.focus();
                    }
                });

                base.cancel.on("click", function(e) {
                    e.preventDefault();

                    base.form.slideUp(200, base.clearForm.bind(base));
                    base.container.removeClass(base.config.editmodusClassname);
                    base.messageHandler.hideMessage();
                });

                base.submitHandler.onBeforeSubmit = function() {
                    base.messageHandler.hideMessage();
                };

                base.submitHandler.handleSubmitResponse = function(data) {
                    if (
                        data.validation.toUpperCase() !== "OK" &&
                        typeof data.fields !== "undefined"
                    ) {
                        base.handleValidationErrors(data.fields);
                    } else {
                        base.updateFields(data);
                        base.form.slideUp(200, base.clearForm.bind(base));
                        base.container.removeClass(
                            base.config.editmodusClassname
                        );
                    }
                    if (typeof data.message !== "undefined") {
                        base.messageHandler.showMessage(data.message);
                    }
                };

                base.submitHandler.handleError = function() {
                    base.form.slideUp(200);
                    base.container.removeClass(base.config.editmodusClassname);
                    base.messageHandler.showMessage(base.config.errorText);
                };
            },

            handleValidationErrors: function(validationArray) {
                var validationObject = new ZZ.FormValidation();
                validationObject.validateMultipleFields(validationArray);
            },

            updateFields: function(data) {
                var base = this,
                    infoContainer,
                    input,
                    newValue;

                infoContainer = base.container.find(".information:first");
                input = base.container.find(".edit-form :input");

                // use returned value from json, if available
                if (data[input.attr("name")] !== undefined) {
                    newValue = data[input.attr("name")];
                }
                // otherwise, get value directly from form input fields
                else {
                    newValue = base.getValue(input);
                }
                infoContainer.html("<span>" + newValue + "</span>");
            },

            // get current text value from (set of) input field(s)
            getValue: function(inputs) {
                var result = "",
                    type = inputs.attr("type");

                // address
                if (
                    inputs.attr("data-lookup-id") &&
                    inputs.attr("data-lookup-id") === "postalcode"
                ) {
                    result = $(inputs[0])
                        .parents(".information-edit, .information.add")
                        .find("[data-lookup-id=result]")
                        .html();
                }
                // checkboxes and radiobuttons
                else if (type === "checkbox" || type === "radio") {
                    var checked = inputs.filter(":checked");
                    checked.each(function() {
                        result += result.length > 0 ? ", " : "";
                        result += $(this).val();
                    });
                }
                // selectbox
                else if (inputs[0].tagName.toLocaleUpperCase() === "SELECT") {
                    result = inputs.find(":selected").text();
                }
                // password
                else if (type === "password") {
                    result = "********";
                }
                // default
                else {
                    result = inputs.val();
                }
                return result;
            },

            clearForm: function() {
                var base = this,
                    inputs = base.form.find(":input");

                inputs.val("");
                inputs.trigger("ZZ_input_hidden");
            }
        };
    })(jQuery);
}
